<template>
    <div class="container">
        <section class="small-container">
            <!-- <h3 class="iconfont iconxiala">订单信息(标*为手动，金额自动计算)</h3>
            <el-row class="colorLine">
                <el-col :span="10">
                    <div style="height: 1px;background: #91002c;"></div>
                </el-col>
                <el-col :span="14">
                    <div style="height: 1px;background: #003570;"></div>
                </el-col>
            </el-row> -->
            <!-- label-width="180px" -->
            <el-form status-icon inline :model="order" :rules="orderRules" ref="order"  :label-width="50" :disabled="readonly">
                <el-row>
                    <!-- <el-col :span="12">
                        <el-form-item label="订单名称：" prop="orderName" class="noMarginBottom">
                            <el-input v-model.trim="order.orderName"
                                      size="mini"
                                      class="minWidth"
                                      placeholder="请输入订单名称" >
                            </el-input>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="8">
                        <el-form-item label="不含税：" prop="amountExclTax" class="noMarginBottom">
                            <el-input v-model.trim="order.amountExclTax"
                                      size="mini"
                                      readonly
                                      class="minWidth"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="含税：" prop="amountWithTax" class="noMarginBottom">
                            <el-input v-model.trim="order.amountWithTax"
                                      size="mini"
                                      readonly
                                      class="minWidth"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="税金：" prop="taxRatioAmount" class="noMarginBottom">
                            <el-input v-model.trim="order.taxRatioAmount"
                                      size="mini"
                                      readonly
                                      class="minWidth"/>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </section>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.component('order',{
    name: "order",
    props: ['amountExclTax', 'amountWithTax', 'readonly'],
    computed: {
        filterArea(){
            if(this.filterId){
                return this.area.filter(item => {
                    return this.filterId.indexOf(item.id) != -1;
                });
            }
            return [];
        }
    },
    watch: {
        amountExclTax(val){
            this.$set(this.order, 'amountExclTax', val);
            this.$set(this.order, "taxRatioAmount", (this.order.amountWithTax - this.order.amountExclTax).toFixed(2));
        },
        amountWithTax(val){
            this.$set(this.order, 'amountWithTax', val);
            this.$set(this.order, "taxRatioAmount", (this.order.amountWithTax - this.order.amountExclTax).toFixed(2));
        }
    },
    data(){
        return {
            filterId: [],
            order:{
                orderName: '',
                amountWithTax: '',
                taxRatioAmount: '',
                amountExclTax: '',
                // companyId: '',
            },
            area:[],
            treeData:[],
            orderRules: {
                orderName: [
                    {
                        required: true,
                        message: '请输入订单名称',
                        trigger: 'blur'
                    },
                ],
                regionalCompanyId: [
                    {
                        required: true,
                        message: '请选择使用区域',
                        trigger: 'blur'
                    },
                ],
                // companyId: [
                //     {
                //         required: true,
                //         message: '请选择项目',
                //         trigger: 'blur'
                //     },
                // ],
            }
        }
    },
    mounted() {
        this.getCompanyList();
        this.getTree();
    },
    methods:{
        getTree(){
            let that = this;
            this.$root.getFunc("v1/sCompany/getCompanyTree",function (res) {
                that.treeData = res.data
            })
        },
        cleanForm(){
            this.order = {
                orderName: '',
                amountWithTax: '',
                taxRatioAmount: '',
                amountExclTax: '',
                companyId: '',
            }
        },
        submitFormPromise(formName){
          return this.submitFormFnc(formName)();
        },
        submitFormFnc(formName){
            let that = this;
            var f = function (){
                const p = new Promise((resolve, reject) => {
                    let form = that.$refs[formName];
                    if(Array.isArray(that.$refs[formName])){
                        form = that.$refs[formName][0]
                    }
                    form.validate((valid) => {
                        if(valid){
                            resolve(true);
                        } else {
                            reject('请完成必填信息的填写！');
                        }
                    });
                });
                return p;
            }
            return f;
        },
        getCompanyList(){
            let that = this;
            that.$root.postFunc('/v1/sRegionalCompany/public/getRegionalCompanyList',{
                "pageFlag": 0,
                "pageNumber": 0,
                "pageSize": 0,
                "regionalCompanyCode": "",
                "regionalCompanyName": ""
            },function (res) {
                that.area = res.data.list
            });
        },
        changeRegionalCompany(val){
            this.$emit('changeRegional', val);
        }
    }
})
</script>

<style lang='scss' scoped>
//@import url(); 引入公共css类

@import '../../../assets/_var.scss';
@import "../../../assets/iconfont/iconfont.css";

.container /deep/{
    // margin-top: -10px;
    // padding-bottom: 15px;
    background-color: #ffffff;

    .el-message-box {
        width: 500px;
    }

    .text-button.el-button {
        font-size: 16px;
        text-align: left;
        color: #333333;
        line-height: 21px;
        background: white;
        border: none;
    }

    .f14 {
        font-size: 14px!important;
    }

    & .unit {
        width: 100px;
        margin-right: 5px;
    }

    & .tip {
        margin-left: 10px;
        color: $--primary-color;
        font-size: 12px;
    }

        & .add {
        float: right;
        font-size: 14px;
        cursor: pointer;
        & img {
            vertical-align: middle;
            width: 70px;
            height: 26px;
        }
    }
    & .dele {
        position: absolute;
        top: 0px;
        right: 10px;
    }
    & .dele img {
        transform: scale(1);
        transition: .5s;
        width: 34px;
        height: 34px;
    }
    .dele:hover img {
        transform: scale(1.1);
    }
    & .remarks {
        width: 95%;
    }

    & .naturalForm  {
        padding: 20px 10px 5px;
        padding-left: 0px;
        padding-right: 26px;
        border: 1px solid #dcdfe6;
        border-radius: 3px;
        margin-bottom: 20px;
    }

    & h4{
        padding: 0 30px;
        text-align: left;
        line-height: 50px;
        color: $--text-color-light;
        background: $--secondary-fill-color;
        overflow: hidden;
        position: relative;

    }
    & h4 {
        text-indent: 10px;
        line-height: 35px;
        background: $--primary-fill-color;
    }

    .attachmentForm {
        .el-form-item__content {
            // width: 250px;
        }
    }

    .el-input__inner {
        border: none;
        border-bottom: 1px solid #C4C4C4;
        border-radius: 0px;
    }

    .el-input.is-disabled .el-input__inner, .el-textarea.is-disabled .el-textarea__inner {
        background-color: white;
        cursor: default;
    }

    .maxWidthForm {
        width: 100%;
        .el-form-item__content {
            width: calc(100% - 260px);
        }
    }

    .onlySupplier {
        .file-list .file-name {
            max-width: 190px!important;
        }
    }

    .el-form-item {
        width: 100%;
    }
    .el-form-item__error {
        width: 300px;
        padding: 0;
    }

    .el-form-item__label, .el-form-item__content{
        line-height: 33px;
    }
}
.box-card{
    margin-bottom: 15px;
}
.minWidth{
    width: 180px;
}
h3{
    // background-color: #ececec;
    padding: 0 20px 5px;
    margin: 0;
    // margin-top: 10px;
    position: relative;
    cursor: pointer;
    padding-left: 25px;
}

.iconxiala::before {
    position: absolute;
    left: 0px;
    font-size: 20px;
}

.colorLine {
    margin-top: 10px;
    margin-bottom: 20px;
    padding-left: 20px;
}

h2 {
    font-size: 13px;
    margin-left: 20px;
}
.noMarginBottom{
    // margin-bottom: 0!important;
    margin-bottom: 10px!important;
    .tipWrap {
        position: relative;
        min-width: 250px;
        .tips {
            position: absolute;
            top: 16px;
            left: 100px;
            padding-left: 20px;
            font-size: 12px;
            color: $--text-color-light;
            // background: url('../../../assets/img/detail/tip.png') no-repeat left center;
        }
    }
}

.cf:before,.cf:after {
    content:"";
    display:table;
}
.cf:after { clear:both; }
</style>



// WEBPACK FOOTER //
// src/pages/order/components/jiesuan.vue